module.exports = __webpack_public_path__ + "static/media/classic-athletics-primary.34c0e1a8.jpg";